import { Output, EventEmitter, Component, OnInit, Input, TemplateRef, AfterViewInit, OnChanges, SimpleChanges, ElementRef, ViewChild, Renderer2 } from '@angular/core';

@Component({
    selector: 'shared-slider-list',
    templateUrl: './slider-list.shared.component.html',
    styleUrls: ['./slider-list.shared.component.scss']
})
export class SliderListComponent implements OnInit, AfterViewInit, OnChanges {
    private _init: boolean = false;
    private _children !: Array<HTMLElement>;

    @Input() public slides: TemplateRef<any>;

    @ViewChild('slidesContainer', { static: true }) public elementRef: ElementRef;

    @Output() public onContentChange: EventEmitter<Array<HTMLElement>> = new EventEmitter();

    constructor(
        public renderer2: Renderer2,
    ) { }

    ngOnInit(): void { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.slides) {
            this._contentChangedEmit();
        }
    }

    ngAfterViewInit(): void {
        this._init = true;

        this._contentChangedEmit();
    }

    private _contentChangedEmit(): void {
        if (!this._init || !this.elementRef || !this.elementRef.nativeElement) return;
        setTimeout(() => {
            this._children = Array.from<HTMLElement>(this.elementRef.nativeElement.children);
            this.renderer2.setStyle(this.elementRef.nativeElement, 'grid-template-columns', `repeat(${this._children.length}, 1fr)`);
            this.renderer2.setStyle(this.elementRef.nativeElement, 'height', null);
            this.renderer2.setStyle(this.elementRef.nativeElement, 'visibility', null);
            this.onContentChange.emit(this._children);
        }, 0);
    }
}
